import { AnalyticsRounded, CalendarMonth, CheckCircleOutline, Circle, EventAvailable, EventRepeat, Person, Task } from '@mui/icons-material'
import { Avatar, Box, Chip, Tooltip, Typography, useTheme } from '@mui/material'
import { IWorkFlow } from '../../definitions/Workflow'
import Formatter from '../../helpers/Formatter'
import Tile from '../layout/Tile'

interface P {
    workflow: IWorkFlow
}

export default function WorkflowInfo({ workflow }: P) {
    const theme = useTheme()

    return (
        <div>
            <div style={{ flex: 1, padding: theme.spacing(1), display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Box marginTop={1} flex={1} display='flex' flexDirection='column'>
                    <Typography marginTop={1} variant='h5' fontWeight='bold'>{workflow.title}</Typography>
                </Box>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <CheckCircleOutline />
                    <Typography variant='body2' width={150}>Status</Typography>
                    <Chip
                        avatar={(
                            <Avatar>
                                <Circle fontSize='small' color={workflow?.status === 'open' ? 'secondary' : 'success'} />
                            </Avatar>
                        )}
                        label={workflow?.status === 'open' ? 'Open' : 'Completed'}
                        color={workflow?.status === 'open' ? 'primary' : 'success'}
                        size='small'
                    />
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <CalendarMonth />
                    <Typography variant='body2' width={150}>Creation Date</Typography>
                    <Typography
                        variant='body2'
                        fontWeight='bold'
                        noWrap>
                        {Formatter.date(new Date(workflow.createdAt), 'long')}
                    </Typography>
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <EventAvailable />
                    <Typography variant='body2' width={150}>Due Date</Typography>
                    <Typography
                        variant='body2'
                        fontWeight='bold'
                        noWrap>
                        {Formatter.date(new Date(workflow.dueDate), 'long')}
                    </Typography>
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <AnalyticsRounded />
                    <Typography variant='body2' width={150}>Contract</Typography>
                    <Typography
                        variant='body2'
                        fontWeight='bold'
                        noWrap>
                        {workflow.contract.name}
                    </Typography>
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <EventRepeat />
                    <Typography variant='body2' width={150}>Repeats</Typography>
                    <Typography
                        variant='body2'
                        fontWeight='bold'
                        noWrap>
                        {workflow.repeats?.name.toString()}
                    </Typography>
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <Task />
                    <Typography variant='body2' width={150}>Tasks</Typography>
                    {workflow?.tasks && (
                        <Typography variant='body2' fontWeight='bold' width={150}>
                            {workflow?.tasks?.map((x, index) => (
                                <span key={x.uuid}>
                                    {x.title}
                                    {index < workflow.tasks.length - 1 && ', '}
                                </span>
                            ))}
                        </Typography>
                    )}
                </Tile.Row>
                <Tile.Row spacing={2} flex={0} alignItems='center' style={{ marginTop: theme.spacing(2) }}>
                    <Person />
                    <Typography variant='body2' width={150}>Creator</Typography>
                    <Box display='flex' alignItems='center'>
                        {workflow?.createdBy && (
                            <Tooltip key={'Current task owner' + workflow.uuid} title={workflow.createdBy.name}>
                                <img src={workflow.createdBy.image} style={{ height: 25, width: 25, borderRadius: '100%' }} />
                            </Tooltip>
                        )}
                    </Box>
                </Tile.Row>
            </div>
        </div>
    )
}
